__turbopack_context__.v({
  "carousel-navigation": "styles-module__dwJEXW__carousel-navigation",
});
